import React, { ReactNode } from 'react';
import { ErrorRounded } from '@mui/icons-material';
import { Box, Paper } from '@mui/material';
import { Main } from './FullPageError.styles';

type Props = {
  title?: string;
  subtitle?: string;
  children: ReactNode;
};

const FullPageError: React.FC<Props> = ({ title = 'Uh oh!', subtitle = 'An Error Occurred', children }) => {
  return (
    <Main>
      <Paper
        sx={{
          padding: '10% 20%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ErrorRounded color="error" fontSize="large" />
        <h1>{title}</h1>
        {subtitle && <strong>{subtitle}</strong>}
        <Box
          sx={{
            marginY: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {children}
        </Box>
      </Paper>
    </Main>
  );
};

export default FullPageError;
